export const environment = {
  TURNSTILE_ENABLED: false,
  TURNSTILE_SITE_KEY: '0x4AAAAAAA_XppWMz_TDONvu',
};
